export const ListQueryKey = 'projectAdminLogins';
export const DetailQueryKey = 'projectAdminLogin';

export const Urls = {
  selectUrl: '/adminloginlog/list',
  updateUrl: '/adminloginlog/update',
  deleteUrl: '/adminloginlog/delete',
  createUrl: '/adminloginlog/create',
  detailUrl: '/adminloginlog/info',
};
